<template>
  <section class="section-cinemas">
    <div class="container">
      <div class="section-space-50"></div>
      <div class="section-header-title position-relative">
        Cinemas
        <!-- <img
          src="@/assets/img/gif/Mascots-popcorn-small.gif"
          alt
          class="home-gif-image"
        /> -->
      </div>
      <div class="section-space-25"></div>
      <!-- <div class="movie-filter d-none d-md-block">
        <ul class="list-inline">
          <li class="list-inline-item hoverEffect text-center">All</li>
          <li class="list-inline-item hoverEffect">
            <b-dropdown id="dropdown-1" text="Location" variant="none">
              <b-dropdown-item>First Action</b-dropdown-item>
            </b-dropdown>
          </li> -->
      <!-- <li class="list-inline-item hoverEffect">
            <b-dropdown id="dropdown-1" text="Format" variant="none">
              <b-dropdown-item>First Action</b-dropdown-item>
              <b-dropdown-item>Second Action</b-dropdown-item>
              <b-dropdown-item>Third Action</b-dropdown-item>
            </b-dropdown>
          </li>-->
      <!-- </ul>
      </div> -->
      <div class="row">
        <div
          :key="cinemaKey"
          v-for="(cinema, cinemaKey) in cinemas"
          class="col-12 col-md-4 col-lg-4 col-xl-4 mb-4"
        >
          <div class="cinema-box text-center">
            <router-link
              to
              @click.native="
                () =>
                  $router.push({
                    name: 'Cinema Details',
                    params: { cinema_code: cinema.Cinema_strID }
                  })
              "
              class="cinema-card"
            >
              <img
                v-lazy="IMAGE_URL + cinema.image_path_1"
                class="img-fluid"
                alt
              />
              <div class="cinema-card-content py-2 px-3">
                <div class="cinema-name">{{ cinema.Cinema_strName }}</div>
                <div class="cinema-location">{{ cinema.cinema_address }}</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="section-space-50"></div>
    </div>
    <applyFilters class="d-md-none" />
  </section>
</template>
<script>
import applyFilters from "@/components/partials/applyFilters";
import LocationService from "@/apiServices/LocationService";
import { mapState, mapGetters, mapActions } from "vuex";
import CinemaService from "@/apiServices/CinemaService";
import { IMAGEURL } from "@/config";
import Vue from "vue";
export default {
  data() {
    return {
      IMAGE_URL: IMAGEURL,
      cinemas: [],
      locations: []
    };
  },
  components: {
    applyFilters
  },
  beforeMount() {
    //  this.onGetCinemaList();
    this.getCinemas();
  },
  methods: {
    ...mapActions(["onGetCinemaList"]),
    async getCinemas(params = {}) {
      let loader = Vue.$loading.show();
      try {
        this.cinemas = [];
        await CinemaService.GetCinemas(params).then(response => {
          const { data } = response;
          if (data && data.status) {
            this.cinemas = data.data;
            console.log("data.data", data.data.data);
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        loader.hide();
      }
    },
    async getLocations() {
      // let loader = Vue.$loading.show();
      this.isCityLoading = false;

      try {
        let search;
        this.search ? (search = this.search) : null;
        const response = await LocationService.GetLocations({ search });
        const { data } = response;
        if (data && data.status) {
          this.locations = data.data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        // loader.hide();
        setTimeout(() => (this.isCityLoading = false), 500);
      }
    }
  },
  destroyed() {
    // if needed reset your store
    //this.onResetMovieStoreState()
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/cinemas.vue